import { Heart } from "lucide-react";
import iconLogo from "../assets/iconLogo.png"


export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center md:text-left">

          {/* ENLACES RÁPIDOS */}
          <div className="flex flex-col items-center md:items-start">
            <h4 className="text-lg font-semibold mb-4">Enlaces Rápidos</h4>

            <ul className="space-y-3 text-gray-300">
              <li><a href="#inicio" className="hover:text-white">Inicio</a></li>
              <li><a href="#productos" className="hover:text-white">Productos</a></li>
              <li><a href="#servicios" className="hover:text-white">Servicios</a></li>
              <li><a href="#contacto" className="hover:text-white">Contacto</a></li>
            </ul>
          </div>

          {/* LOGO + TEXTO PRINCIPAL */}
          <div className="col-span-1 md:col-span-2 flex flex-col items-center md:items-start">

            <div className="flex flex-col items-center md:flex-row md:space-x-4 mb-4">
              <img
                src={iconLogo}
                width={50}
                style={{ borderRadius: "12px" }}
                className="mb-3 md:mb-0"
              />

              <div>
                <h3 className="text-xl font-bold">Ser Efimed S.A.</h3>
                <p className="text-gray-400 text-sm mt-1">Servicio y Eficiencia Médica</p>
              </div>
            </div>

            <p className="text-gray-300 max-w-md mt-2">
              Ser Efimed S.A., con más de 23 años de experiencia en la venta de material y equipo médico,
              ha establecido relaciones de confianza con instituciones públicas y privadas, incluida la CCSS.
              La empresa garantiza productos con respaldo científico y certificaciones, asegurando calidad 
              y cumplimiento regulatorio para un óptimo desempeño en áreas críticas de atención y diagnóstico.
            </p>
          </div>

          {/* HORARIO */}
          <div className="flex flex-col items-center md:items-start">
            <h4 className="text-lg font-semibold mb-4">Horario</h4>
          
            <div className="text-gray-300 space-y-1">
              <p>Lunes - Viernes: 7:00 - 17:00</p>
              <p>Sábado y Domingo: Cerrado</p>
            </div>
          </div>
          
        </div>


        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>© 2025 Ser Efimed S.A. Todos los derechos reservados.</p>
        </div>

      </div>
    </footer>
  );
}
